const ENVIRONMENTS = {
  terraframing: 'prod',
  'terraframing-test': 'test',
  'terraframing-dr': 'dr',
};

const COGNITO_POOLS = {
  prod: 'us-east-1_JL0xgfrhp',
  test: 'us-east-1_2Sm5d7tpQ',
  dr: 'us-east-1_Pi7InWl8t',
  development: 'us-east-1_2Sm5d7tpQ',
};

const COGNITO_CLIENTS = {
  prod: '64ub2fr7trtiinb7h44v1upodq',
  test: 'ofu9sn3vdfdsqj1v911b0n0rs',
  dr: '712s1rgbdbutmlqnkfpa1m5smq',
  development: 'ofu9sn3vdfdsqj1v911b0n0rs',
};

const GTM_ENVIRONMENTS = {
  dr: {
    gtmId: 'GTM-KDML739',
    auth: 'S_GcIhUlKcSeX9UTPXKKJw',
    preview: 'env-3',
  },
  test: {
    gtmId: 'GTM-KDML739',
    auth: 'LntaviqPD_nEcv4ogf7jPg',
    preview: 'env-6',
  },
  prod: {
    gtmId: 'GTM-KDML739',
    auth: 'DyHPtLV3kCy2qPkyR7PLYw',
    preview: 'env-1',
  },
};

const subDomain = window.location.host.split('.')[0];
const environment = ENVIRONMENTS[subDomain] || 'development';
const isDevelopment = environment === 'development';
const isDr = environment === 'dr';
const isProd = environment === 'prod';

export default {
  environment,
  isDevelopment,
  isProd,
  apiUrl: buildApiUrl(),
  googleTagManagerArgs: GTM_ENVIRONMENTS[environment],
  muiLicense: `142796011371c5449145efa85b36bfe2Tz0xMTY5NjgsRT0xNzg1NTQyMzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj0yMDIyLEtWPTI=`,
  googleMapsApiKey: isProd
    ? `AIzaSyAuHigYdx-ZXob6nJjaZz7HLCL4fzd_TtM`
    : `AIzaSyAYgV1N-zddljX6bxO0KN9ZDL4xT_x1cBo`,

  Auth: {
    region: 'us-east-1',
    userPoolId: COGNITO_POOLS[environment],
    userPoolWebClientId: COGNITO_CLIENTS[environment],
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },

  rollbar: {
    accessToken: 'f1a989cf785c4dc6baf7000e8a049587',
    environment,
    enabled: !isDevelopment && !isDr,
  },

  tillageTypes: [
    { id: 'Conventional', label: 'Conventional' },
    { id: 'Minimum till', label: 'Minimum Till' },
    { id: 'No-Till', label: 'No-Till' },
    { id: 'Strip-till', label: 'Strip-Till' },
  ],

  fertilizerProducts: [
    {
      id: 1,
      name: '10-34-0',
      nitrogen: 10,
      phosphorus: 34,
      potassium: 0,
      sulfur: 0,
      density: 11.72,
    },
    {
      id: 2,
      name: '32-0-0',
      nitrogen: 32,
      phosphorus: 0,
      potassium: 0,
      sulfur: 0,
      density: 11.04,
    },
    {
      id: 3,
      name: '12-0-0-26',
      nitrogen: 12,
      phosphorus: 0,
      potassium: 0,
      sulfur: 26,
      density: 11.1,
    },
    {
      id: 4,
      name: '6-24-6',
      nitrogen: 6,
      phosphorus: 24,
      potassium: 6,
      sulfur: 0,
      density: 11.25,
    },
    {
      id: 5,
      name: '9-18-9',
      nitrogen: 9,
      phosphorus: 18,
      potassium: 9,
      sulfur: 0,
      density: 11.2,
    },
    {
      id: 6,
      name: '0-0-25-17',
      nitrogen: 0,
      phosphorus: 0,
      potassium: 25,
      sulfur: 17,
      density: 12.2,
    },
    {
      id: 7,
      name: '28-0-0',
      nitrogen: 28,
      phosphorus: 0,
      potassium: 0,
      sulfur: 0,
      density: 10.67,
    },
  ],
};

function buildApiUrl() {
  const uiPort = Number(document.location.port || 0);

  /*
   * For local development: The node server always runs on an even port, but we may be
   * running with a react dev server that is running on the next port (which will be odd)
   */
  const apiPort = uiPort % 2 ? uiPort - 1 : uiPort;

  const host = [document.location.hostname, apiPort].filter(Boolean).join(':');
  return `${document.location.protocol}//${host}/api`;
}
